export enum FlowchartLinkValueType {
    textValue = 'textValue',
    numericalValue = 'numericalValue',
    booleanValue = 'booleanValue',
    dateTimeValue = 'dateTimeValue',
    timeSpanValue = 'timeSpanValue',
    numericalValueRange = 'numericalValueRange',
    textValueRange = 'textValueRange',
    dateTimeValueRange = 'dateTimeValueRange',
    textValueArray = 'textValueArray',
    numericalValueArray = 'numericalValueArray',
    codeableConceptValueArray = 'codeableConceptValueArray',
}
